import { EventType, EventTypeCondition, ReplyType, ReplyTypeLabels } from "../enums/event-type.enum";
import { SendToType } from "../enums/send-to-type.enum";

const EVENT_TYPE_LABELS: Partial<Record<string, string>> = {
  no_response: 'No Response',
};

export function eventTypesToDropdownOptions<T extends object>(e: T, sendTo: SendToType): { label: string; value: string }[] {
  return Object.values(e)
    .filter(value => {
      if (sendTo === SendToType.EXTERNAL_LEAD) {
        // No Showing templates: only show Pulled event type
        return value === EventType.PULLED;
      }
      // All other template types: exclude Pulled and emailResponder (emailResponder only for LEAD)
      if (value === EventType.PULLED) return false;
      if (value === EventType.EMAILRESPONDER && sendTo !== SendToType.LEAD) return false;
      return true;
    })
    .map(value => ({
      label: value.charAt(0).toUpperCase() + value.slice(1),
      value
    }));
}

export function eventConditionsToDropdownOptions<T extends object>(e: T, sendTo?: SendToType): { label: string; value: string }[] {
  return Object.values(e)
    .filter(value => {
      if (sendTo === SendToType.EXTERNAL_LEAD) {
        // No Showing: only Immediate and No Response
        return value === EventTypeCondition.IMMEDIATE || value === EventTypeCondition.NO_RESPONSE;
      }
      // All other types: exclude no_response
      return value !== EventTypeCondition.NO_RESPONSE;
    })
    .map(value => ({
      label: EVENT_TYPE_LABELS[value] ?? (value.charAt(0).toUpperCase() + value.slice(1)),
      value
    }));
}

export function templateScopesToDropdownOptions<T extends object>(e: T): { label: string; value: string }[] {
  return Object.values(e).map(value => ({
    label: value.charAt(0).toUpperCase() + value.slice(1), // Capitalize
    value
  }));
}

export function replyTypesToDropdownOptions(e: typeof ReplyType): { label: string; value: string }[] {
  return Object.values(e).map(value => ({
    label: ReplyTypeLabels[value as ReplyType] || value,
    value
  }));
}